import { render, staticRenderFns } from "./QuizGrade.vue?vue&type=template&id=21ba68f2&"
import script from "./QuizGrade.vue?vue&type=script&lang=js&"
export * from "./QuizGrade.vue?vue&type=script&lang=js&"
import style0 from "./QuizGrade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports